import React from 'react'
import Card from './utils/Card'

const cardInfo = {
  header: `Let us know when you've arrived.`,
  text: `We'll keep your order fresh until you let us know you're ready for it. Make sure you click the green button once you've arrived.`,
  action: {
    text: `I'm ready to collect`,
    variant: 'tertiary',
  },
  stage: 'baySelection',
  dataCy: 'ready-to-collect',
}

const cardInfoArrivalSuccess = {
  header: `Thank you - we'll be with you shortly.`,
  text: `We’re just checking a few final details. A colleague will bring your shopping out to you as soon as possible.`,
  stage: 'arrived',
  dataCy: 'arrived',
}

const cardInfoCollectedOrder = {
  header: 'Your order has been collected.',
  text: `According to our details, your order has been fulfilled.`,
  action: {
    text: 'Check your order details',
    variant: 'secondary',
    icon: 'openInNew',
  },
  stage: 'alreadyCollected',
  dataCy: 'already-collected',
}

const OrderInfoCard = props => {
  const {
    orderData,
    arrivalStatus,
    onArrivalClick,
    onOrderDetailsClick,
  } = props

  function isValidOrder() {
    return (
      orderData && orderData.length && orderData[0].readyForCollection === true
    )
  }

  function getCardProps() {
    let cardProps
    switch (true) {
      case arrivalStatus:
        cardProps = cardInfoArrivalSuccess
        break
      case isValidOrder():
        const timeLine = {
          start: orderData[0].collectionSlotStart,
          end: orderData[0].collectionSlotEnd,
        }
        cardProps = {
          ...cardInfo,
          timeLine,
          onActionClick: onArrivalClick,
        }
        break
      default:
        cardProps = {
          ...cardInfoCollectedOrder,
          onActionClick: onOrderDetailsClick,
        }
        break
    }
    return cardProps
  }

  return <Card key="card-info" {...getCardProps()} />
}

export default OrderInfoCard
